"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_home__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c5c4d89d-7f37-48fd-8d9b-d0b22e581b9e",
    x1: 68,
    y1: 69.4,
    x2: 154.61,
    y2: 156.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "home-02-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "16550737-5819-4841-9165-ccf5e6a28a3a",
    "data-name": "Home_ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,168H56a16,16,0,0,1-16-16V97.4l56-56,56,56V152a16,16,0,0,1-16,16H80Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 116,
    width: 32,
    height: 52,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 114,
    width: 32,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124 36 140 36 140 77.4 124 61.4 124 36",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.51,101.39h0a8.49,8.49,0,0,1-6-2.49L96,41.4,38.56,98.84a8.49,8.49,0,0,1-6,2.49h0a8.49,8.49,0,0,1-6-14.49L84.69,28.71a16,16,0,0,1,22.63,0l58.19,58.19A8.49,8.49,0,0,1,159.51,101.39Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,166H56a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h80a16,16,0,0,0,16-16v-2A16,16,0,0,1,136,166Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.94,91.92a8.49,8.49,0,0,1-14.43,5L152,95.4l-56-56-56,56h0l-1.44,1.44a8.49,8.49,0,0,1-14.43-5,8.49,8.49,0,0,0,14.43,7L40,97.4l56-56,56,56,1.51,1.51a8.49,8.49,0,0,0,14.43-7Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,97.4,110.83,168H136a16,16,0,0,0,16-16V97.4l-56-56Z",
    opacity: 0.2,
    fill: "url(#c5c4d89d-7f37-48fd-8d9b-d0b22e581b9e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_home__dark;
exports.default = _default;